<template>
  <div class="shop-car-header mb-20 flex items-center justify-between">
    <h2 class="flex items-center">
      <icon class="car-icon" :icon-name="icon"/>
      <span class="shop-car-header-title">{{title}}</span>
    </h2>

    <slot />
  </div>
</template>

<script>
export default {
  props:['title', 'icon']
}
</script>

<style lang="less" scoped>
.shop-car-header{
  padding: .16rem 0;
  border-bottom: 1px solid #ccc;
  &-title{
    font-size: .34rem;
  }

  .car-icon{
    width: .5rem;
    height: .5rem;
    font-size: .26rem;
  }
}
</style>